import React from 'react';
import { StarIcon } from 'lucide-react';
import { Testimonial } from '../../utils/types';
interface TestimonialsSectionProps {
  testimonials: Testimonial[];
}
export const TestimonialsSection: React.FC<TestimonialsSectionProps> = ({
  testimonials
}) => {
  return <section className="py-20 bg-gray-50" data-id="element-134">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-136">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-137">
            What our users are saying
          </h2>
          <p className="text-lg text-gray-600" data-id="element-138">
            Hear from the developers and companies using our platform
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-139">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300" data-id="element-140">
              <div className="flex mb-4" data-id="element-141">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-5 h-5 ${i < testimonial.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-142" />)}
              </div>
              <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-143">
                "{testimonial.content}"
              </p>
              <div className="flex items-center" data-id="element-144">
                <div className="w-12 h-12 mr-4" data-id="element-145">
                  <img src={testimonial.avatar} alt={testimonial.name} className="w-full h-full rounded-full object-cover" data-id="element-146" />
                </div>
                <div data-id="element-147">
                  <h4 className="font-semibold text-gray-900" data-id="element-148">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-149">
                    {testimonial.title}, {testimonial.company}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};